var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F6E5FE",
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.5c.621 0 1.125.504 1.125 1.125v9.75a1.125 1.125 0 0 1-2.25 0v-9.75c0-.621.504-1.125 1.125-1.125m-5.835 3.075c.439.44.439 1.15 0 1.59a8.25 8.25 0 1 0 11.67 0 1.125 1.125 0 0 1 1.59-1.59c4.1 4.1 4.1 10.749 0 14.849-4.101 4.1-10.749 4.1-14.85 0-4.1-4.1-4.1-10.748 0-14.849a1.125 1.125 0 0 1 1.59 0",
    fill: "#821BB8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStep1);
export default __webpack_public_path__ + "static/media/icon-step-1.3fa9ab22fb8d3774c6643ef806ed916f.svg";
export { ForwardRef as ReactComponent };